import { InputText } from "primereact/inputtext"
const _props = {
    className: '',
    htmlAttributes: {},
    id: '',
    field: {},
    form: {},
    rules: {}
}
export const EmailControl = (props = _props) => {
  
    return <>
        <InputText validateOnly  autoComplete="off" id={props.field.name} {...props.field}  {...props.htmlAttributes} className={props.className} />
    </>
}